// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EZsT7cfORI_vaWJKAUFE{
  display: grid;
  height: 100%;
}

.a6CGBOjQWPB80cKe7N3G {
  font-weight: 800;
  padding: 2rem;
  font-size: 1.8rem;
}

._8WHqnT7GyqhO7A1r4hZ{
  display: flex;
  align-items: center;
  padding: 0.5rem;
  gap: 2rem;
 }

.S6Y3IE2m1W8zebFYXmdK {
  width: 2rem;
  height: 2rem;
}

.qU9TX7sAWs8tJu0nCotg {
  margin-top: 60px;
  margin-bottom: 25px;
  margin-left: 10px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-transform: uppercase;

  color: #000000;
}

.OBOb4pBvn6U5abn2dFU6{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/CartilhasOrgao/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;CACV;;AAED;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;;EAEzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf","sourcesContent":[".card{\n  display: grid;\n  height: 100%;\n}\n\n.h1 {\n  font-weight: 800;\n  padding: 2rem;\n  font-size: 1.8rem;\n}\n\n.header{\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  gap: 2rem;\n }\n\n.button {\n  width: 2rem;\n  height: 2rem;\n}\n\n.dividerText {\n  margin-top: 60px;\n  margin-bottom: 25px;\n  margin-left: 10px;\n  font-family: \"Montserrat\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  text-transform: uppercase;\n\n  color: #000000;\n}\n\n.flex{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  width: 100%;\n  height: 100%;\n  padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `EZsT7cfORI_vaWJKAUFE`,
	"h1": `a6CGBOjQWPB80cKe7N3G`,
	"header": `_8WHqnT7GyqhO7A1r4hZ`,
	"button": `S6Y3IE2m1W8zebFYXmdK`,
	"dividerText": `qU9TX7sAWs8tJu0nCotg`,
	"flex": `OBOb4pBvn6U5abn2dFU6`
};
export default ___CSS_LOADER_EXPORT___;
